import LinkTabs from "@/components/link-tabs";

export const SETTINGS_TABS = [
  { key: "company", label: "회사" },
  { key: "template", label: "공종 템플릿" },
  { key: "trades", label: "공종·공정" },
  { key: "prices", label: "단가표" },
  { key: "codes", label: "코드값" },
  { key: "contract", label: "계약" },
  { key: "members", label: "멤버" },
  { key: "intake", label: "간편접수" },
  { key: "notify", label: "알림" },
] as const;

export type SettingsTab = (typeof SETTINGS_TABS)[number]["key"];

export const DEFAULT_TAB: SettingsTab = "company";

/** URL 의 `?tab=` 은 사람이 손으로 고칠 수 있다 — 아는 값일 때만 받는다. */
export const toTab = (value: string | string[] | undefined): SettingsTab =>
  SETTINGS_TABS.find((tab) => tab.key === value)?.key ?? DEFAULT_TAB;

export const tabHref = (tab: SettingsTab): string =>
  tab === DEFAULT_TAB ? "/app/settings" : `/app/settings?tab=${tab}`;

/**
 * 탭. 상태가 아니라 링크다 — 새로고침·뒤로가기에 살아남고, 「단가표 이 화면」 을
 * 그대로 보낼 수 있다. 자바스크립트 없이도 넘어간다.
 */
const SettingsTabs = ({ current }: { current: SettingsTab }) => (
  <LinkTabs
    activeHref={tabHref(current)}
    aria-label="설정 탭"
    items={SETTINGS_TABS.map((tab) => ({ label: tab.label, href: tabHref(tab.key) }))}
  />
);

export default SettingsTabs;
